export const GET_SUMMARY_REPORT='GET_SUMMARY_REPORT'
export const GET_REPORT_TABLE='GET_REPORT_TABLE'
export const SET_REPORT_FILTER='SET_REPORT_FILTER'
export const SET_TABLE_TITLE='SET_TABLE_TITLE'
export const GET_CHART='GET_CHART'
export const GET_REPORT_EXCEL='GET_REPORT_EXCEL'